import { Box } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextHeadline } from '@cbhq/cds-web/typography';

type FilterButtonProps = {
  label: string;
  onPress: () => void;
  isSelected: boolean;
};

// note: mimick cds button component size. If Button changes,
// we need to update this accordingly
const pressableStyle = { maxHeight: '44px', paddingInline: '10px' };

function FilterButton({ label, onPress, isSelected }: FilterButtonProps) {
  const btnBackgroundColor = isSelected ? 'foreground' : 'backgroundAlternate';
  const textHeadlineColor = isSelected ? 'primaryForeground' : 'foreground';
  return (
    <Pressable
      onPress={onPress}
      as="button"
      background={btnBackgroundColor}
      borderRadius="roundedFull"
      style={pressableStyle}
    >
      <Box as="div" spacing={1} justifyContent="center">
        <TextHeadline as="span" color={textHeadlineColor} align="center" noWrap>
          {label}
        </TextHeadline>
      </Box>
    </Pressable>
  );
}

export default FilterButton;
